module.exports = __webpack_public_path__ + "img/gregory_porter.0f4b078e.jpg";